import React from 'react'
import { Col, Row, Input, Label } from 'reactstrap';
import { Dialog } from 'primereact/dialog';

export const ModalCommonDiscounts = (props) => {
    const {
        // ? DIALOG
        modal,
        toggle,

        // ? INPUTS
        arrayCommonDiscounts,
        clearDiscount,
        newDiscount,
        validPorcentejeSpecial,
        setValidateCommonDiscountDetail,
        isEditWorkOrder,
        validateCommonDiscountDetail

    } = props;

    const hasCommonDiscount = arrayCommonDiscounts.some(d => d.is_available_discount);
    setValidateCommonDiscountDetail(hasCommonDiscount);

    return (
        <Dialog
            visible={modal}
            onHide={toggle}
            modal
            maskClassName="custom-discount-mask"
            draggable={false}
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-tag"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Campaña activa
                            </div>


                        </div>

                    </div>
                </div>
            }

            className={`Global-dialog Global-dialog Global-blue Global-small-v `}
        >
            <Row className='pt-3' >
                <Col sm="12">

                    {
                        validPorcentejeSpecial === "https://labcen.helen-sw.com" && (arrayCommonDiscounts.length > 0 && !isEditWorkOrder && !validateCommonDiscountDetail) &&
                        <div className="discount-alert">
                            <i className="fa fa-info-circle"></i>
                            Una vez activada la campaña ya no se podra desactivar.
                        </div>
                    }
                    <div className="common-discount-container">
                        {
                            arrayCommonDiscounts.length > 0 &&
                            arrayCommonDiscounts.map((_common, index) => (
                                <div
                                    key={index}
                                    className={`common-discount-card ${_common.is_available_discount ? "active" : ""}`}
                                >
                                    <div className="common-discount-switch">
                                        <Label className='switch'>
                                            <Input
                                                type='checkbox'
                                                id={`CommonDiscount-${_common.id_common_discount}`}
                                                checked={_common.is_available_discount}
                                                disabled={!_common.is_enable}
                                                onChange={(e) =>
                                                    validPorcentejeSpecial === "https://labcen.helen-sw.com"
                                                        ? newDiscount(e, _common.id_common_discount)
                                                        : clearDiscount(e, _common.id_common_discount)
                                                }
                                            />
                                            <span className='slider round'></span>
                                        </Label>
                                    </div>

                                    <div className="common-discount-info">
                                        <span className="title">{_common.name}</span>
                                        <span className="dates">
                                            Válido: {_common.valid_from} - {_common.valid_to}
                                        </span>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </Col>
            </Row>
        </Dialog>
    )

}

